import { render, staticRenderFns } from "./DebtorView.vue?vue&type=template&id=2a613cb0&scoped=true"
import script from "./DebtorView.vue?vue&type=script&lang=js"
export * from "./DebtorView.vue?vue&type=script&lang=js"
import style0 from "./DebtorView.vue?vue&type=style&index=0&id=2a613cb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a613cb0",
  null
  
)

export default component.exports